<samweb-avatar-status-selection [userId]="userId$ | async"></samweb-avatar-status-selection>
